<template>
  <div class="app-container">
    <el-main>

      <div class="platDiv" @click="addClass('1')"
          :class="{ spanColors: platform === '1' }">
      <img
          src="@/assets/tb.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2.3px" />
      <span class="platSpan">淘宝</span>
    </div>
    <div class="platDiv" style="width: 96px" @click="addClass('2')"
          :class="{ spanColors: platform === '2' }">
      <img
          src="@/assets/pdd.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;margin-top: -1px" />
      <span class="platSpan">拼多多</span>
    </div>
    <div class="platDiv" @click="addClass('3')"
          :class="{ spanColors: platform === '3' }">
      <img
          src="@/assets/dy.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;margin-top: -1px" />
      <span class="platSpan">抖音</span>
    </div>
    <div class="platDiv" @click="addClass('4')"
          :class="{ spanColors: platform === '4' }">
      <img
          src="@/assets/jd.jpeg"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;border-radius: 0.5em;" />
      <span class="platSpan">京东</span>
    </div>
    <div class="platDiv" @click="addClass('5')"
          :class="{ spanColors: platform === '5' }">
      <img
          src="@/assets/ks.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;border-radius: 0.5em;" />
      <span class="platSpan">快手</span>
    </div>
    <div style="float: left;margin-left: 400px;" v-show="this.strip > 0">
      <span v-if="this.strip>0">{{ pingtai_data_cang }} ：{{ strip }}单</span>
    </div>

        <br><br>
      <div
        style="font-weight: bold; font-size: 16px; color: rgb(85, 85, 85); float: left;margin-top: 5px;"
      >
        <!-- 选择发送物流 -->
        手动发货
      </div>
      <br />
      <div class="zfxx" style="margin-top: 10px">
        <svg width="22" height="22">
          <circle
            cx="10"
            cy="10"
            r="8"
            stroke="#dee6fe"
            stroke-width="1"
            fill="#dee6fe"
          />
          <circle
            cx="10"
            cy="10"
            r="3"
            stroke="#0850fc"
            stroke-width="3"
            fill="#0850fc"
          />
        </svg>
        <span class="djb">第一步</span>
      </div>
      <div
        style="margin-left: 10px; border-left: #c3c3c3 dashed 1px; padding-bottom: 10px"
      >
        <div class="djb_desc">选择发送物流</div>
        <div style="margin-left: 20px; margin-top: 5px; padding-bottom: 10px">
          <!-- <span class="select_span">代发仓库</span> -->
          <el-select
            style="width: 25vw; margin-left: 0px"
            v-model="lpfsQuery.pingtai_data_id"
            @change="cangkuClick"
          placeholder="代发仓库"
            class="filter-item"
          >
            <el-option
              v-show="!item.desc_name.includes('抖音-自发货物流-----智能数字物流1号-抖音电子面单（帮助商家实时推送货物物流节点和取件码信息给买家）') && !item.desc_name.includes('店铺取号偏远地区礼品测试请勿使用')"
              v-for="item in cangkuList"
              :key="item.id"
              :label="item.desc_name"
              :value="item.id"
            >
              <span>
                <img
                  :src="item.kuaidi.pic"
                  alt="图标"
                  style="width: 60px; height: 30px; margin-right: 8px"
                />
                {{ item.desc_name }}
              </span>
            </el-option>
          </el-select>
          <!-- <span style="margin-left: 1vw">￥ {{ lpfsQuery.kuaidi_price }} 元</span> -->
        </div>
      </div>

      <div class="zfxx">
        <svg width="22" height="22">
          <circle
            cx="10"
            cy="10"
            r="8"
            stroke="#dee6fe"
            stroke-width="1"
            fill="#dee6fe"
          />
          <circle
            cx="10"
            cy="10"
            r="3"
            stroke="#0850fc"
            stroke-width="3"
            fill="#0850fc"
          />
        </svg>
        <span class="djb">第二步</span>
      </div>

      <div
        style="margin-left: 10px; border-left: #c3c3c3 dashed 1px; padding-bottom: 10px"
      >
        <div class="djb_desc">填写发货信息</div>
        <div style="display: flex; flex-wrap: wrap; align-items: flex-start;">
          <div
          class="select_span"
          style="margin-left: 20px; margin-top: 5px; padding-bottom: 5px;  width: 480px;"
        >
          <span style="padding: 0 10px 0 10px; border-right: #c3c3c3 solid 1px"
            >发货地址</span
          >
          <input style="width: 380px; margin-left: 7px;height:29px" v-model="fhAddress" readonly />
          </div>

          <div
          class="select_span"
          style="margin-left: 20px; margin-top: 5px; padding-bottom: 5px; width: 200px;"
        >
          <span style="padding: 0 10px 0 10px; border-right: #c3c3c3 solid 1px">发件人姓名</span
          ><input
            style="width: 100px; margin-left: 7px;height:29px"
            v-model="send_name"
            placeholder="刘先生"
          ></input>
          </div>
          <div class="select_span"
          style="margin-left: 20px;margin-top: 5px; width: 220px;padding:5px 7px">
          <span style="border-right: #c3c3c3 solid 1px; padding-right: 7px;">发件人电话</span>
          <el-dropdown trigger="click" placement="bottom-start">
              <span class="el-dropdown-link">
                {{ send_tel }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                      v-for="(item, index) in sendtelList"
                      :key="index"
                      :label="item"
                      :value="item">
                  <!-- <div style="display: flex; justify-content: space-between; align-items: center;"> -->
                    <span @click="liClicked(item)">{{ item }}</span> &nbsp;&nbsp;&nbsp;
                    <el-button type="text" style="color: red;" @click="deleteItem(item)">删除</el-button>
                  <!-- </div> -->
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
          <div
          style="margin-left: 20px;margin-top: 5px; width: auto;padding:0px 7px">
          
          <el-button
              style="
                font-size: 12px;
                color: #0850fc;
                border-color: #0850fc;
                height: 34px;
                border-radius: 0.5em;
                padding: 3px 10px;
              "
              @click="sendCodeCheck()"
              >添加手机号</el-button
            >
            <!-- <div style="margin-top: -38px; margin-left: 80px; width: 410px">
            <span style="color: red">验证说明:请填写可接听电话手机号，作为发件人电话。此电话将作为物流派送和投诉电话使用，请随时接听物流派送或投诉等问题.</span></div> -->
          </div>
        </div>
        <div class="djb_desc" style="margin-top: 3px">代发礼品：</div>
        <div style="margin-top: 5px; padding-bottom: 10px">
          <div v-for="(item, index) in goods" :key="index" class="lipin_img_div">
            <img :src="item.pic" alt="Image" class="lipin_img" />
            <br />
            <div>
              <el-input v-model="lpfsQuery.goods_id" v-show="false"></el-input>
              <el-input v-model="lpfsQuery.goods_price" v-show="false"></el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="zfxx">
        <svg width="22" height="22">
          <circle
            cx="10"
            cy="10"
            r="8"
            stroke="#dee6fe"
            stroke-width="1"
            fill="#dee6fe"
          />
          <circle
            cx="10"
            cy="10"
            r="3"
            stroke="#0850fc"
            stroke-width="3"
            fill="#0850fc"
          />
        </svg>
        <span class="djb">第三步</span>
      </div>
      <div style="margin-left: 10px">
        <div class="djb_desc">输入收件地址</div>
        <div style="margin-top: 5px; margin-left: 20px">
          <el-button
            style="
              font-size: 12px;
              color: #0850fc;
              border-color: #0850fc;
              height: 34px;
              border-radius: 0.5em;
              padding: 5px 15px;
            "
            @click="selectFile"
            >批量导入收货地址</el-button
          >

          <input
            type="file"
            style="display: none"
            ref="fileInput"
            @change="handleFileUpload"
          />
          <el-button
            style="
              font-size: 12px;
              color: #0850fc;
              border-color: #0850fc;
              height: 34px;
              border-radius: 0.5em;
              padding: 5px 15px;
              margin-left: 20px;
            "
            @click="downLoadDrmb"
            >下载导入表格模板</el-button
          >
          <el-button
            style="
              font-size: 12px;
              color: #0850fc;
              border-color: #0850fc;
              height: 34px;
              border-radius: 0.5em;
              padding: 5px 15px;
              margin-left: 20px;
            "
            @click="downLoadWhymb"
            >下载无货源专用模板</el-button
          >
        </div>
        <div style="margin-top: 7px; margin-left: 20px">
          <textarea
            v-model="shAddressList"
            :placeholder="textarea_placeHolder"
            @blur="assignToList"
          ></textarea>
        </div>

        <div style="margin-top: 7px">
          <el-button
            type="primary"
            style="
              font-size: 12px;
              background-color: #0850fc;
              color: white;
              height: 34px;
              border-radius: 0.5em;
              padding: 10px 12px;
              margin-left: 20px;
            "
            @click="buyLp"
            :disabled="isDisabled"
            >开始生成</el-button
          >
          <el-button
            type="primary"
            style="
              font-size: 12px;
              background-color: #0850fc;
              color: white;
              height: 34px;
              border-radius: 0.5em;
              padding: 10px 12px;
              margin-left: 20px;
            "
            @click="handleDownload"
            >导出表格数据</el-button
          >
        <span v-if="isDisabled" style="margin-left:30px;color:red;font-size:22px">已选订单正在发送礼品，不要重复点击发送按钮，请耐心等待 。 。 。</span>
        </div>
      </div>
      <div
        style="
          font-weight: bold;
          font-size: 20px;
          color: rgb(85, 85, 85);
          margin-top: 10px;
        "
      >
        生成列表
      </div>

      <el-table
        v-loading="listLoading"
        v-horizontal-scroll
        :data="handleList"
        highlight-current-row
        style="color: rgb(70, 70, 70); margin-top: 7px"
        :row-style="{ height: '0' }"
        :cell-style="{ padding: '3px 0' }"
        :header-cell-style="{
          background: 'rgb(247 248 252) !important',
          color: '#ededed  !important',
          padding: '7px 0',
          color: 'rgb(140, 140, 140)',
        }"
      >
        <el-table-column label="店铺名称" prop="shop_name" align="left" min-width="2">
          <template slot-scope="{ row }">
            <span>{{ row.shop_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" prop="order_no" min-width="2" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.order_no">{{ row.order_no }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="addressee" min-width="1" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.addressee">{{ row.addressee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobile" align="left" min-width="2">
          <template slot-scope="{ row }">
            <span>{{ row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="详细地址" prop="allAddress" min-width="3" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.allAddress">{{ row.allAddress }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="上家快递公司"
          prop="express_pro"
          min-width="2"
          align="left"
        >
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.express_pro">{{ row.express_pro }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="上家快递单号"
          prop="express_no"
          align="left"
          min-width="2"
        >
          <template slot-scope="{ row }">
            <span>{{ row.express_no }}</span>
          </template>
        </el-table-column>
        <el-table-column label="快递公司" prop="kdName" min-width="2" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.kdName">{{ row.kdName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="生成快递单号" prop="newOrder" min-width="2" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.newOrder">{{ row.newOrder }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remarks" align="left" min-width="2">
          <template slot-scope="{ row }">
            <span>{{ row.remarks }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 自动发送实时返回数据展示弹出框 -->
      <el-dialog
        title="发送结果"
        :visible.sync="dialogFormVisible"
        style="
          text-align: center;
          width: 100%;
          height: 120%;
          overflow-y: auto;
          padding: 0px;
        "
      >
        <el-form
          :model="lpfsResult"
          style="
            width: 100%;
            height: 100%;
            overflow-y: auto;
            white-space: pre-line;
            text-align: left;
            margin-top: -50px;
          "
        >
          <el-form-item style="padding: 0; margin: 0">
            <span>
              {{ lpfsResult.data }}
            </span></el-form-item
          >
        </el-form>
      </el-dialog>

      <!-- 短信验证弹出框 -->
      <el-dialog
        title="添加手机号-短信验证"
        :visible.sync="sendCodeFormVisible"
        style="
          text-align: center;
          width: 60%;
          height: 120%;
          overflow-y: auto;
          padding: 0px;
          margin-left: 16%;
          margin-top: 5%;
        "
      >
        <el-form
         class="form"
              :model="phoneForm"
              :rules="rules"
              ref="phoneForm"
              label-width="0px"
            >
            <!-- <div style="margin-bottom: 20px;color:red">
            因移动手机号运营商问题，验证码接收失效率高，尽量切换电信或联通手机号
            </div> -->
              <el-form-item prop="phone">
                <el-input
                  v-model="phoneForm.phone"
                  placeholder="请输入手机号"
                  prefix-icon="el-icon-mobile-phone"
                ></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input
                  v-model="phoneForm.code"
                  placeholder="请输入验证码"
                  prefix-icon="el-icon-chat-line-round"
                ></el-input>
                <!-- <a type="button" @click="sendCode">获取验证码</a> -->
                <a type="button" @click="sendCode" :disabled="countdown > 0">
                  {{ countdown > 0 ? `${countdown}秒后重新获取` : "获取验证码" }}
                </a>
              </el-form-item>
            </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateUserInfo()"> 确认 </el-button>
        <el-button @click="sendCodeFormVisible = false"> 取消 </el-button>
      </div>
      </el-dialog>
    </el-main>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import waves from "@/directive/waves"; // waves directive
import "@/assets/custom-theme/index.css"; // the theme changed version element-ui css
import { DatePicker } from "element-ui";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import * as XLSX from "xlsx";

export default {
  name: "lipinOrder",
  directives: { waves },
  components: {
    Pagination,
    "el-date-picker": DatePicker,
  },
  data() {
    return {
      cangkuList: [],
      selected_kuaidi: { id: "", desc_name: "" },
      fhAddress: "",
      price: "",
      fhName: "",
      goods: [],
      goodsImg: "",
      // platList: [
      //   { value: 1, name: "淘宝" },
      //   { value: 2, name: "拼多多" },
      //   { value: 3, name: "抖音" },
      //   { value: 4, name: "京东" },
      //   { value: 5, name: "快手" },
      // ],
      listLoading: false,
      shAddressList: "",
      longText: "",
      textarea_placeHolder:
        "通用格式:姓名,手机,详细地址,商品订单号(必填),上家发货单号(无货源专用必填),上家快递公司(无货源专用必填) 以下示例:\n\
王二,13912345222,河北省 石家庄市 赵县 恒阳街 都景园小区13-2-1102,1547703326419135418,464631307971352,韵达快递,淘宝,拼多多\r\n\
张三,13912345333,浙江省 台州市 临海市 大田街 铁路大道合景天峻13-2-1102,1547703326419118979,JT5031307971352,极兔快递\r\n\
李四,13912345444,上海 上海市 徐汇区华泾镇 龙吴路2888弄14号1302室,1547703326419118979\r\n\
请严格按照上面的方法添加收货信息;每一行一个地址,按回车分行注意:地址用空格分割!\r\n\
输入完成后点下方检査收货地址进行核对,请认真核对!\r\n\
出单号就无法退款,勿因格式问题造成损失注意:单次最多支持200条地址",

      list: [],
      handleList: [],
      lpfsQuery: {
        list: [],
        pingtai_data_id: "",
        express_type: 1,
        goods_id: "",
        goods_price: "",
        kuaidi_price: "",
        fjr: "",
        zdy_phone: "",
        fsTk: 2,
        ckType: "",
      },
      user_balance: "",
      pingtai_data_cang: "",
      strip: 0,
      cang_prefixText: "代发仓库",
      dialogFormVisible: false,
      lpfsResult: { data: "" },
      platform: 1,
      send_name:"",
      send_tel: "",
      sendtelList:[],
      sendCodeFormVisible: false,
      phoneForm:{
        phone: "",
        code:"",
      },
      countdown: 0, // 倒计时时间
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "手机号格式错误", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      exportList:[],
      isDisabled: false,
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      // this.isLogin = false;
      // this.$confirm("请先登录再使用！", "提示", {
      //   confirmButtonText: "确定",
      // })
      //   .then(() => {
      //     // 重新导航到登录页面
      //     localStorage.clear();
      //     this.$root.removeCookies();
      //     this.$router.push({ path: "/login" });
      //   })
      //   .catch(() => {
      //     // 重新导航到首页
      //     localStorage.clear();
      //     this.$root.removeCookies();
      //     this.$router.push({ path: "/" });
      //   });
      // return;
    } else {
      this.$root.getSystemInfo();
      this.addClass('1');
      this.getUserBalance();

      this.selectedItems = this.orderTypes;
      this.selectPalts = this.buyPlatforms;
      this.selectKuaidis = this.kuaidiLists;
      // this.$root.getUserInfo();
      
      if (Cookies.get("view_sendName") != null && Cookies.get("view_sendName") != "null" && Cookies.get("view_sendName") != ""  && Cookies.get("view_sendName") != "undefined"  && Cookies.get("view_sendName") != undefined) {
        this.send_name = Cookies.get("view_sendName");
      }
      if (Cookies.get("view_sendTel") != null && Cookies.get("view_sendTel") != "null" && Cookies.get("view_sendTel") != ""  && Cookies.get("view_sendTel") != "undefined"  && Cookies.get("view_sendTel") != undefined) {
        this.sendtelList = JSON.parse(Cookies.get("view_sendTel"));
      }

      if (Cookies.get("view_fjr") != null && Cookies.get("view_fjr") != "null" && Cookies.get("view_fjr") != undefined && Cookies.get("view_fjr") != "undefined") {
        const fjrStr = Cookies.get("view_fjr");
        this.lpfsQuery.fjr = fjrStr;
        const index = fjrStr.indexOf(',');
        if (index != -1) {
          const st = fjrStr.substring(index + 1); // 逗号后面的部分
          if (this.sendtelList.indexOf(st) != -1) {
            this.send_tel = st;
          }
        }
        const index1 = fjrStr.indexOf('，');
        if (index1 != -1) {
          const st1 = fjrStr.substring(index1 + 1); 
          if (this.sendtelList.indexOf(st1) != -1) {
            this.send_tel = st1;
          }
        }
      } else {
        this.lpfsQuery.fjr = "";
      }
      
    }
  },
  computed: {
    //订单状态 全选事件
    isAllOt_Selected: {
      get() {
        return this.selectedItems.length === this.orderTypes.length;
      },
      set(value) {
        if (value) {
          this.selectedItems = this.orderTypes.slice();
        } else {
          this.selectedItems = [];
        }
      },
    },
    // 采购平台 全选事件
    isAllbp_Selected: {
      get() {
        return this.selectPalts.length === this.buyPlatforms.length;
      },
      set(value) {
        if (value) {
          // this.buyPlatforms.forEach((item) => {
          //   this.selectPalts.push(item.id);
          // });
          this.selectPalts = this.buyPlatforms.slice();
        } else {
          this.selectPalts = [];
        }
      },
    },
    // 匹配快递 全选事件
    isAllkd_Selected: {
      get() {
        return this.selectKuaidis.length === this.kuaidiLists.length;
      },
      set(value) {
        if (value) {
          // this.buyPlatforms.forEach((item) => {
          //   this.selectPalts.push(item.id);
          // });
          this.selectKuaidis = this.kuaidiLists.slice();
        } else {
          this.selectKuaidis = [];
        }
      },
    },
  },
  methods: {
    getList() {},
    getCk() {
      //更换平台时，调用接口获取平台对应仓库列表
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.cangkuList = [];
      this.lpfsQuery.pingtai_data_id = "";
      this.lpfsQuery.ckType = "";
      this.fhAddress = "";
      this.goods = [];

      const url = this.$root.commonPreUrl + "/index/getCk";
      const system_id = Cookies.get("view_system_id");
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: { platform: this.platform, system_id: system_id },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.cangkuList = resd.data;
            this.cangkuList.forEach((item) => {
              // 快递图标加前缀
              item.kuaidi.pic = this.$root.staticUrl + "storage/" + item.kuaidi.pic;
              // 仓库名称后面加上价格展示
              item.desc_name = item.desc_name + "，￥" + item.processed_member;
            });
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    cangkuClick() {
      const selected_cid = this.lpfsQuery.pingtai_data_id;
      // 使用forEach方法遍历数组并取值
      this.cangkuList.forEach((item, index) => {
        const cid = item.id;
        if (cid == selected_cid) {
          // 给快递赋值
          // this.selected_kuaidi = item.kuaidi;
          // 快递费
          this.lpfsQuery.kuaidi_price = item.processed_member;
          // 给发货地址赋值
          this.fhAddress = item.address;
          //  给代发礼品赋值
          this.goods = item.goods;
          this.goods.forEach((item, index) => {
            item.pic = this.$root.staticUrl + "storage/" + item.pic;
          });
          this.lpfsQuery.goods_id = this.goods[0].id;
          this.lpfsQuery.goods_price = this.goods[0].member;
          this.lpfsQuery.ckType = this.type;
        }
      });
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });
        // 将每一行数据拼接成字符串
        this.shAddressList = jsonData
          .slice(1)
          .map((row) => [row[2], row[3], row[4], row[1], row[6], row[5], row[7], row[8]])
          .join("\n");
        // this.longText = jsonData.slice(1);
        //表格展示数据
        this.handleList = [];
        this.list = jsonData.slice(1);
        this.list.forEach((item, index) => {
          
          let dpPlat = 0;
          if (item[7] == '淘宝') {
            dpPlat = 0;
          } else if  (item[7] == '京东') {
            dpPlat = 2;
          }  else if (item[7] == '拼多多') {
            dpPlat = 4;
          } else if (item[7] == '抖音')  {
            dpPlat = 5;
          } else if (item[7] == '快手') {
            dpPlat = 6;
          } else if (item[7] == '小红书')  {
            dpPlat = 7;
          }
          let cgPlat = 0;
          if (item[8] == '1688') {
            cgPlat = 0;
          } else if  (item[8] == '京东') {
            cgPlat = 2;
          }  else if (item[8] == '拼多多') {
            cgPlat = 4;
          } else if (item[8] == '抖音')  {
            cgPlat = 5;
          } else if (item[8] == '快手') {
            cgPlat = 6;
          } else if (item[8] == '小红书')  {
            cgPlat = 7;
          }
          let allAddress = item[4];
          let lpfsData = {
            shop_name: item[0],
            order_no: item[1],
            allAddress: allAddress,
            address: allAddress.split(" ")[4],
            province: allAddress.split(" ")[0],
            city: allAddress.split(" ")[1],
            area: allAddress.split(" ")[2],
            town: allAddress.split(" ")[3],
            mobile: item[3],
            addressee: item[2],
            express_no: item[6],
            express_pro: item[5],
            kdName: "",
            newOrder: "",
            remarks: "",
            // 0902  加四个参数 sourcecode  targetname  enterchannel  deliverychannel
            sourcecode: item[6],
            targetname: item[8],
            enterchannel: dpPlat,
            deliverychannel: cgPlat,
          };
          this.handleList.push(lpfsData);
        });
      };
      reader.readAsArrayBuffer(file);
    },
    selectFile() {
      this.$refs.fileInput.click(); // 触发文件选择
    },
    async buyLp() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }
      const sendTel = this.send_tel;
      if (sendTel == "" || sendTel == "null" || sendTel == null || sendTel == undefined || sendTel == "undefined") {
        this.$confirm("请先选择正确的发件人电话！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            return;
          })
          .catch(() => {
            return;
          });
        return;
      }
      let sendName = this.send_name;
      if (sendName=="") {
        sendName = "1"
      }
      this.lpfsQuery.fjr = sendName + "," + sendTel;

      let data = this.handleList;
      if (data == [] || data.length == 0) {
        this.$confirm("请先导入收货地址信息再生成单号!", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false, //是否显示取消按钮
        })
          .then(() => {})
          .catch(() => {});
        return;
      }

      this.isDisabled = true;
      let allDatas = [];
      data.forEach((item) => {
        if (item) {
          if (
            item.express_no == null ||
            item.express_no == "" ||
            item.express_no == undefined
          ) {
            item.express_no = "";
          }
        }
        allDatas.push(item);
      });

      this.listLoading = true;
      this.lpfsResult.data = "";
      // this.dialogFormVisible = true;
      const url = this.$root.commonPreUrl + "/index/buyLp";

      // allDatas.forEach((item) => {
      for (let index = 0; index < allDatas.length; index++) {
        const item = allDatas[index];

        if (item.order_no == "" || item.order_no == undefined || item.order_no == "undefined" || item.order_no == null || item.order_no == "null") {
          this.$confirm("商品订单号不能为空，请按格式输入后再试!", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false, //是否显示取消按钮
        })
          .then(() => {})
          .catch(() => {});
          return;
        }
        
        let lpfsParams = JSON.parse(JSON.stringify(this.lpfsQuery));
        lpfsParams.list = JSON.stringify([item]);
        lpfsParams = JSON.stringify(lpfsParams);
        const headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userToken,
        };
        const res = axios.post(url, lpfsParams, { headers: headers });
        res
          .then((response) => {
            const resd = response.data;
            if (resd.code == "200") {
              // this.lpfsResult.data =
              //   this.lpfsResult.data +
              //   item.order_no +
              //   "--生成礼品单成功，生成快递单号：" +
              //   resd.buylp_no +
              //   "；\n";
              //  给表格数据赋值
              data.forEach((item1) => {
                if (
                  item1.addressee == item.addressee &&
                  item1.mobile == item.mobile &&
                  item1.address == item.address &&
                  item1.express_no == item.express_no
                ) {
                  item1.kdName = resd.data.kdName;
                  item1.newOrder = resd.data.newOrder;
                  item1.remarks = resd.msg;
                }
              });
            } else {
              // this.lpfsResult.data =
              //   this.lpfsResult.data +
              //   item.order_no +
              //   "--发送失败，原因：" +
              //   resd.msg +
              //   " ;\n";
              data.forEach((item1) => {
                if (
                  item1.addressee == item.addressee &&
                  item1.mobile == item.mobile &&
                  item1.address == item.address &&
                  item1.express_no == item.express_no
                ) {
                  item1.remarks = resd.msg;
                }
              });
            }
            setTimeout(() => {
              return;
            }, 1.5 * 1000);
          })
          .catch((error) => {
            console.error("初始请求失败:", error);
            if (
              JSON.stringify(error).includes("Error: Request failed with status code 401")
            ) {
              this.$confirm("登录信息已失效，请重新登录!", "提示", {
                confirmButtonText: "确认",
                showCancelButton: false, //是否显示取消按钮
              })
                .then(() => {
                  // 重新导航到首页
                  localStorage.clear();
                  this.$root.removeCookies();
                  this.$router.push({ path: "/login" });
                })
                .catch(() => {});
            }

            return;
          });
          if (index == allDatas.length - 1) {
            // this.dialogFormVisible = true;
            this.isDisabled = false;
          }
      };
      // this.dialogFormVisible = false;
      this.getUserBalance();
      this.listLoading = false;
      //this.isDisabled = false;
    },

    // 长文本框失焦时  重新给list赋值
    assignToList() {
      if (this.shAddressList.trim()) {
        //this.list.push(this.shAddressList.trim());
        this.shAddressList = JSON.parse(
          JSON.stringify(this.shAddressList).replace(/，/g, ",")
        );

        this.list = this.shAddressList
          .split("\n")
          .filter((line) => line.trim())
          .map((line) => line.split(","));

        this.handleList = [];
        this.list.forEach((item, index) => {
          let dpPlat = 0;
          if (item[6] == '淘宝') {
            dpPlat = 0;
          } else if  (item[6] == '京东') {
            dpPlat = 2;
          }  else if (item[6] == '拼多多') {
            dpPlat = 4;
          } else if (item[6] == '抖音')  {
            dpPlat = 5;
          } else if (item[6] == '快手') {
            dpPlat = 6;
          } else if (item[6] == '小红书')  {
            dpPlat = 7;
          }
          let cgPlat = 0;
          if (item[7] == '1688') {
            cgPlat = 0;
          } else if  (item[7] == '京东') {
            cgPlat = 2;
          }  else if (item[7] == '拼多多') {
            cgPlat = 4;
          } else if (item[7] == '抖音')  {
            cgPlat = 5;
          } else if (item[7] == '快手') {
            cgPlat = 6;
          } else if (item[7] == '小红书')  {
            cgPlat = 7;
          }
          let allAddress = item[2];
          let lpfsData = {
            shop_name: "",
            //order_no: "",
            allAddress: allAddress,
            address: allAddress.split(" ")[4],
            province: allAddress.split(" ")[0],
            city: allAddress.split(" ")[1],
            area: allAddress.split(" ")[2],
            town: allAddress.split(" ")[3],
            mobile: item[1],
            addressee: item[0],
            express_no: item[4],
            order_no: item[3],
            express_pro: item[5],
            kdName: "",
            newOrder: "",
            remarks: "",
            // 0902  加四个参数 sourcecode  targetname  enterchannel  deliverychannel
            sourcecode: item[4],
            targetname: item[7],
            enterchannel: dpPlat,
            deliverychannel: cgPlat,
          };
          this.handleList.push(lpfsData);
        });
        
      } else {
        this.list = [];
        this.handleList = [];
      }
    },

    getUserBalance() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      const url = this.$root.commonPreUrl + "/index/getUserBalance";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });

      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            const data = resd.data;
            this.user_balance = data.user_balance;
            if (data.userStrip.length > 0) {
              this.pingtai_data_cang = data.userStrip[0].pingtai_data_cang;
              this.strip = data.userStrip[0].strip;
            }

            Cookies.set("view_userBalance", data.user_balance, { expires: 1 });
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },

    // 导出
    handleDownload() {
      this.downloadLoading = true;

      let listx = this.handleList;
      this.exportList.push(...listx);

      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "店铺名称",
          "订单编号",
          "姓名",
          "手机号",
          "详细地址",
          "上家快递公司",
          "上家快递单号",
          "快递公司",
          "生成快递单号",
          "备注",
        ];
        let filterVal = [
          "shop_name","order_no","addressee","mobile","allAddress","express_pro","express_no","kdName","newOrder","remarks"
        ];
        let data = [];
        data = this.formatJson(filterVal);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "手动发货生成单号列表",
        });
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal) {
      return this.exportList.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    addClass: function (plat) {
      this.platform = plat;
      this.getCk();
    },
    sendCode() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      if (this.countdown > 0) {
        return;
      }
      let phoneNum = this.phoneForm.phone;
      if (phoneNum == "" || phoneNum == null) {
        // alert("请输入手机号！");
        this.$confirm("请输入手机号！", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false, //是否显示取消按钮
        })
          .then(() => {
            return;
          })
          .catch(() => {});
        return;
      }
      const url = this.$root.commonPreUrl + "/sendVerificationCode";
      const res = axios.get(url, {
        params: { phone: phoneNum },
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            // 设置倒计时时间，这里设置为60秒
            this.countdown = 60;
            // 创建倒计时
            const intervalId = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown -= 1;
              } else {
                clearInterval(intervalId);
              }
            }, 1000);
          } else {
            this.$confirm(
              "发送失败！原因：" + JSON.stringify(response.data.message),
              "提示",
              {
                confirmButtonText: "确认",
                showCancelButton: false, //是否显示取消按钮
              }
            )
              .then(() => {
                return;
              })
              .catch(() => {});
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          this.$confirm("操作失败！请稍后刷新重试。", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {
              
            })
            .catch(() => {});
          return;
        });
    },
    sendCodeCheck(){
      this.sendCodeFormVisible = true;
    },
    updateUserInfo(){
      const userToken = Cookies.get("view_userToken");
      const userId = Cookies.get("view_userId");
      if (userToken == undefined || userId == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return "";
      }
      const url = this.$root.commonPreUrl + "/verifyVerificationCode";
      const res = axios.get(url, {
        params: { phone: this.phoneForm.phone, code: this.phoneForm.code },
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            // 提交修改手机号
            const url = this.$root.commonPreUrl + "/index/updateUserInfo";
            this.sendtelList.push(this.phoneForm.phone);
            let sendtel_json = JSON.stringify(this.sendtelList);
            
            const res1 = axios.get(url, {
              params: { id: userId, send_name: this.send_name, send_tel: sendtel_json  },
              headers: {
                Authorization: "Bearer " + userToken,
              },
            });
            res1
              .then((response) => {
                const resd1 = response.data;
                if (resd1.code == "200") {
                  this.sendCodeFormVisible = false;
                  this.$confirm(resd1.message, "提示", {
                    confirmButtonText: "确认",
                    showCancelButton: false, //是否显示取消按钮
                  })
                    .then(() => {
                    
                    })
                    .catch(() => {});
                }else {
                  this.$confirm(resd1.message, "提示", {
                    confirmButtonText: "确认",
                    showCancelButton: false, //是否显示取消按钮
                  })
                    .then(() => {
                    
                    })
                    .catch(() => {}); 
                }
              })

          } else {
            this.$confirm(resd.message, "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {
             
            })
            .catch(() => {});
          return;
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          this.$confirm("操作失败！请稍后刷新重试。", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {
             
            })
            .catch(() => {});
          return;
        });
    },
    sendTelClick(){
      let sendName = this.send_name;
      if (sendName=="") {
        sendName = "1"
      }
      this.lpfsQuery.fjr = sendName + "," + this.send_tel;
    },
    
    liClicked(item){
      this.send_tel = item;
      let sendName = this.send_name;
      if (sendName=="") {
        sendName = "a1"
      }
      this.lpfsQuery.fjr = sendName + "," + this.send_tel;
    },
    deleteItem(item) {
      this.sendtelList = this.sendtelList.filter(i => i !== item);

      const userToken = Cookies.get("view_userToken");
      const userId = Cookies.get("view_userId");
      if (userToken == undefined || userId == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return "";
      }
      const url = this.$root.commonPreUrl + "/index/updateUserInfo";
      let sendtel_json = JSON.stringify(this.sendtelList);
      
      const res1 = axios.get(url, {
        params: { id: userId, send_name: this.send_name, send_tel: sendtel_json  },
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res1
        .then((response) => {
          const resd1 = response.data;
          if (resd1.code == "200") {
            this.sendCodeFormVisible = false;
            this.$root.getUserInfo();
            this.$confirm("手机号删除成功！", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
              
              })
              .catch(() => {});
          }else {
            this.$confirm(resd1.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
              
              })
              .catch(() => {}); 
          }
        })
    },
    downLoadDrmb(){
      import("@/vendor/Export2Excel").then((excel) => {
        let tHeader = [];
        let data = [];
        let fn = "";

        tHeader = [
          "店铺名称(非必填)",
          "订单编号(必填)",
          "姓名(必填)",
          "手机(必填)",
          "详细地址（省市县区空格隔开)",
          "上家快递公司(同步物流必填)",
          "上家快递单号(同步物流必填)",
          "店铺平台(中通转中通必填)",
          "采购平台(中通转中通必填)",
        ];

        let d1 = ["","3509351165279174930","陈秋方","13175465503-8837","浙江省 台州市 临海市 大田街 铁路大道合景天峻13-2-1102","韵达快递","463108429569677","淘宝","拼多多"];
        let d2 = ["","1965754344760399496","李卫霞","18936913963","上海 上海市 徐汇区 华泾镇 龙吴路2888弄14号1302室","中通快递","78365457599935","淘宝","抖音"];
        let d3 = ["","1966594623234149088","刘寨红","18466859636-1301","江苏省 宿迁市 沭阳县 南湖街道 上海南路都市雅苑2号楼2单元1503","极兔速递","JT5217581612517","淘宝","小红书"];
        data.push(d1);
        data.push(d2);
        data.push(d3);

        fn = "导入模版";

        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: fn,
        });
        this.downloadLoading = false;
      });
    },
    downLoadWhymb(){
      import("@/vendor/Export2Excel").then((excel) => {
        let tHeader = [];
        let data = [];
        let fn = "";

        tHeader = [
          "店铺名称(非必填)",
          "订单编号(必填)",
          "姓名(必填)",
          "手机(必填)",
          "详细地址（省市县区空格隔开",
          "上家快递公司(无货源同步必填)",
          "上家快递单号(无货源同步必填)",
          "店铺平台(中通转中通必填)",
          "采购平台(中通转中通必填)",
        ];

        let d1 = ["","3509351165279174930","陈秋方","13175465503-8837","浙江省 台州市 临海市 大田街 铁路大道合景天峻13-2-1102","韵达快递","463108429569677","淘宝","拼多多"];
        let d2 = ["","1965754344760399496","李卫霞","18936913963","上海 上海市 徐汇区 华泾镇 龙吴路2888弄14号1302室","中通快递","78365457599935","淘宝","拼多多"];
        let d3 = ["","1966594623234149088","刘寨红","18466859636-1301","江苏省 宿迁市 沭阳县 南湖街道 上海南路都市雅苑2号楼2单元1503","","JT5217581612517","淘宝","拼多多"];
        data.push(d1);
        data.push(d2);
        data.push(d3);

        fn = "无货源专用模板";

        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: fn,
        });
        this.downloadLoading = false;
      });
    },
  },
};
</script>

<style scoped>
.app-container {
  width: 100%;
}
.el-main {
  width: auto;
  margin-top: 1.5vh;
  background-color: white;
  margin-left: 0.8vw;
  margin-right: 0.8vw;
  text-align: left;
}
.btncs_blue {
  font-size: 13px;
  background-color: #0850fc;
  color: white;
  height: 38px;
  border-radius: 0.5em;
  margin-left: 59px;
  margin-top: 7px;
}
.btncs_gray {
  font-size: 13px;
  background-color: rgb(187 187 187);
  color: white;
  height: 38px;
  border-radius: 0.5em;
  margin-left: 59px;
  margin-top: 7px;
}
.kdselectc {
  width: 20vw;
}
.lipin_img_div {
  width: 5vw;
  height: 5vw;
  /* min-height: 22.5vh; */
  border: white 2px solid;
  border-radius: 1.3em;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  /* background-color: #d5e1ff; */
  color: rgb(37, 37, 37);
  margin-left: 20px;
}
.lipin_img {
  width: 4.7vw;
  height: 4.6vw;
  padding-left: 0.1vw;
  margin-top: 0.1vw;
  border-radius: 1em;
}
textarea {
  border-radius: 0.5em;
  border: 1px solid #ccc; /* 设置你想要的边框颜色 */
  height: 20vh;
  width: 100%;
}
textarea:focus {
  outline: none; /* 移除默认的蓝色边框 */
  border: 1px solid #ccc; /* 设置你想要的边框颜色 */
}
.zfxx {
  /* margin-top: 3px; */
  display: flex;
  align-items: center; /* 垂直居中 */
}
.djb {
  color: rgb(120 120 120);
  margin-left: 10px;
}
.djb_desc {
  font-weight: bold;
  font-size: 15px;
  color: #202020;
  margin-left: 20px;
  padding-top: 3px;
}
.select_span {
  font-size: 14px;
  border: #dcdfe6 1px solid;
  border-radius: 4px;
  height: 32px;
  /* line-height: 34px;
  padding: 11px; */
  color: #606266;
  margin-left: 20px;
  margin-top: 5px;
  padding-bottom: 10px;
}
select {
  height: 30px;
  /* border: #c3c3c3 solid 1px; */
  border: none;
  border-radius: 0.4em;
  outline: none;
}
select:focus {
  outline: none; /* 移除轮廓线 */
}
/* 去掉option的边框 */
option {
  border: none;
  outline: none;
}
.select-option:hover {
  border-color: #0000ff;
  background-color: #ffff00;
}
input {
  height: 30px;
  /* border: #c3c3c3 solid 1px; */
  border: white solid 0px;
  border-radius: 0.4em;
}
input:focus {
  outline: none; /* 移除轮廓线 */
}
.platDiv {
  width: 80px;
  height: 32px;
  border: #0850fc solid 1px;
  border-radius: 0.5em;
  float: left;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  margin-right: 20px;
}
.platSpan{
  font-size: 16px;
  padding: 0px 7px;
}
.spanColors {
  font-weight: bold;
  background-color: #0850fc;
  color: white;
  width: 80px;
  height: 32px;
}
.form a {
  position: absolute;
  text-decoration: none;
  right: 10px;
  color: #a9a9a9;
  border-left: 1px solid #ccc;
  align-items: center;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/lipinOrder/index.vue